<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Estado de Cuenta de Cliente</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <small v-if="current.errors && current.errors.cliente_nit" class="form-text text-danger">{{
                    current.errors.cliente_nit }}</small>

                  <label v-bind:class="{
                    'text-danger':
                      current.errors & current.errors.cliente_nit,
                  }"></label>
                  <ClientesSelectComponent :current="current" @onChangeCliente="refreshClienteDefault">
                  </ClientesSelectComponent>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="current.fecha_inicial" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="current.fecha_final" />
                </div>
              </div>
              <div class="col-12">
                <div>
                  <button class="btn btn-md" style="background-color: green;" @click="refresh(current)">
                    <i class="fas fa-search	"></i>
                    Buscar
                  </button>
                  <button class="btn btn-md btn-dark" @click="refreshDataDefault">
                    <i class="fas fa-undo"></i>
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="btn-group dropdown">
                    <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" style="background-color: #eb8e15;"><i class="fas fa-plus"></i>
                      Más Opciones
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                      <button class="dropdown-item" @click="imprimirResumido">
                        Ver todos con Saldo Pendiente
                        <i class="fas fa-file-invoice-dollar"></i>
                      </button>
                      <button class="dropdown-item" data-toggle="modal" data-target="#VoucherECModal">
                        Imprimir Voucher Estado Cta.
                        <i class="fas fa-receipt"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <br>
                <div style="text-align: right;">
                  <label>Mostrar solo con saldo pendiente</label>
                  <div class="col-12">
                    <input type="checkbox" :value="true" v-model="current.solo_con_saldo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-buttons-w">
              <router-link v-if="current.producto" class="btn btn-outline-info" :to="{
                name: 'cat-productos-editar',
                params: { sku: current.producto.sku },
              }">
                <i class="fa fa-arrow-left"></i>
                Ir al Producto
              </router-link>
            </div>
            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div>
                <h5>Listado de Movimientos</h5>
              </div>
              <div style="text-align: right;">
                <button v-if="datos" @click="imprimir(det)" class="btn btn-secondary btn-sm">
                  <span>Imprimir</span>
                  &nbsp;
                  <i class="fas fa-print"></i>
                </button>
              </div>
              <br />
              <br />
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th style="width: 8%">Nit</th>
                      <th>Nombre</th>
                      <th>Dirección</th>
                      <th>Documento</th>
                      <th style="width: 10%">Fecha</th>
                      <th class="text-right">cargos</th>
                      <th class="text-right">abonos</th>
                      <th class="text-right">Saldo</th>
                      <th class="text-right">Acumulado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td>{{ item.nit }}</td>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.direccion }}</td>
                      <td>{{ item.documento }}</td>
                      <td>{{ item.fecha }}</td>
                      <td class="text-right">{{ item.cargos }}</td>
                      <td class="text-right">{{ item.abonos }}</td>
                      <td class="text-right">{{ item.saldo }}</td>
                      <td class="text-right">{{ item.acumulado }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Inicio Modal Impresión Voucher -->
      <div class="modal fade" id="VoucherECModal" tabindex="-1" role="dialog" aria-labelledby="VoucherECModal"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="VoucherECModal">Impresión Voucher</h5>
            </div>
            <div class="modal-body">
              <ClientesSelectComponent :current="current" @onChangeCliente="refreshClienteDefault">
              </ClientesSelectComponent>
              <TiendaSelectComponent :current="current" @onChangeCliente="refreshClienteDefault">
              </TiendaSelectComponent>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="refreshDataDefault" data-dismiss="modal">X</button>
              <button type="button" class="btn btn-primary" @click="imprimirVoucherEC()">Generar <i
                  class="fas fa-check"></i></button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin de Modal Impresión Voucher-->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      det: {
        fecha_final: "",
        fecha_inicial: "",
        solo_con_saldo: "",
      },
      current: {
        fecha_final: null,
        fecha_inicial: null,
        cliente_nit: "",
        solo_con_saldo: "",
        errors: {
          cliente_nit: "",
        },
      },
      datos: "",
    };
  },
  methods: {
    imprimirResumido() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/estado_cuenta_resumido.jrxml`
      );
    },
    imprimirVoucherEC() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let nit = this.current.cliente_nit.nit;
      let tienda = this.current.tienda;
      let user = localStorage.getItem("username");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/Estado_cta_voucher.jrxml&nit=${nit}&tienda=${tienda}&usuario=${user}`
      );
      $("#VoucherECModal").modal("hide");
      self.refreshDataDefault()
    },
    refreshClienteDefault() {
      let self = this;
      self.current.errors.cliente_nit = "";
      self.current.fecha_final = "";
      self.current.fecha_inicial = "";
      self.current.solo_con_saldo = "";
    },
    refreshDataDefault() {
      let self = this;
      self.current.errors.cliente_nit = "";
      self.current.cliente_nit = "";
      self.current.fecha_final = "";
      self.current.fecha_inicial = "";
      self.current.solo_con_saldo = "";
      self.current.tienda = "";
      self.datos = "";
    },
    imprimir(det) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (self.current.cliente_nit) {
        det.cliente_nit = self.current.cliente_nit.nit;
      }
      if (!det.fecha_final && !det.fecha_inicial) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/estado_cuenta.jrxml&nit=${det.cliente_nit}`
        );
        return;
      }
      if (!det.fecha_inicial) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/estado_cuenta.jrxml&nit=${det.cliente_nit}&fecha_max=${det.fecha_final}`
        );
        return;
      }
      if (!det.fecha_final) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/estado_cuenta.jrxml&nit=${det.cliente_nit}&fecha_min=${det.fecha_inicial}`
        );
        return;
      }
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=cxc/estado_cuenta/estado_cuenta.jrxml&nit=${det.cliente_nit}&fecha_min=${det.fecha_inicial}&fecha_max=${det.fecha_final}`
      );
    },
    refresh(current) {
      let self = this;
      if (current.solo_con_saldo == true) {
        self.det.solo_con_saldo = 1;
      } else {
        self.det.solo_con_saldo = 0;
      }
      if (current.cliente_nit) {
        self.det.cliente_nit = current.cliente_nit.nit;
      } else {
        self.det.cliente_nit = "";
        alert("¡No ha seleccionado ningun cliente!")
        return
      }
      if (current.fecha_final) {
        self.det.fecha_final = current.fecha_final;
      } else {
        delete self.det.fecha_final;
      }
      if (current.fecha_inicial) {
        self.det.fecha_inicial = current.fecha_inicial;
      } else {
        delete self.det.fecha_inicial;
      }
      console.log(self.det);
      DynamicService.getAction(
        "cat",
        "clientes",
        self.det.cliente_nit,
        "estado_cuenta",
        self.det
      )
        .then((res) => {
          self.datos = res.data.estado_cuenta;

        })
        .catch((err) => { });
    },
  },
};
</script>
